export const API_CONFIG = {
  core: process.env.REACT_APP_CORE_API || 'https://vidhiguruapi.vidhiguru.in',
  billing: process.env.REACT_APP_BILLING_API || 'https://vidhiguruapi.vidhiguru.in',
  file: process.env.REACT_APP_FILE_API || 'https://vidhiguruapi.vidhiguru.in',
  misc: process.env.REACT_APP_MISC_API || 'https://vidhiguruapi.vidhiguru.in',
};

// Superadmin key for admin API calls (set via REACT_APP_SUPERADMIN_KEY env var)
export const ADMIN_KEY = process.env.REACT_APP_SUPERADMIN_KEY || '';

export const API_ENDPOINTS = {
  // Core API
  agents: '/api/agents',
  agentById: (id: string) => `/api/agents/${id}`,
  query: '/api/query',
  queryStream: '/api/query/stream',
  queryPro: '/api/query/pro',
  queryProStream: '/api/query/pro/stream',
  sessions: '/api/sessions',
  
  // Billing API
  billing: '/api/billing',
  billingUsage: '/api/billing/usage',
  billingHistory: '/api/billing/history',
  logQuery: '/api/log-query',
  usageStats: '/api/usage-stats',

  // Settings
  settings: '/api/settings',
  
  // Admin endpoints
  admin: {
    agents: '/api/admin/agents',
    agentById: (id: string) => `/api/admin/agents/${id}`,
    knowledge: '/api/admin/knowledge',
  }
};
